export enum RequestState {
	IDLE,
	PENDING,
	SUCCESS,
	ERROR,
}

export enum ModalType {
	ERROR,
	CONFIRM,
	SAVE_PICKS,
	LOSE_PICKS,
	SHARE_PICKS,
	WELCOME_LP,
	FINAL_SAVE,
	OFF_SEASON,
}

export enum TutorialType {
	LIGHT_PREDICTOR = "lp",
	HEAVE_PREDICTOR = "hp",
}

export enum SortOrder {
	ASC = "asc",
	DESC = "desc",
}

export enum RoundStatus {
	Scheduled = "scheduled",
	Playing = "playing",
	Complete = "complete",
}

export enum TournamentStatus {
	Scheduled = "scheduled",
	Playing = "playing",
	Complete = "complete",
	Canceled = "canceled",
}

export enum SocialNetwork {
	Facebook,
	Twitter,
	Mobile,
}

export enum ShareType {
	General = "general",
	League = "league",
}

export enum Locale {
	EN_US = "en-US",
	ES_MX = "es-MX",
	EN_GB = "en-GB",
	EN_CA = "en-CA",
	EN_AU = "en-AU",
	FR_FR = "fr-FR",
	DE_DE = "de-DE",
	PT_BR = "pt-BR",
}

export enum Language {
	EN = "en",
	ES = "es",
	FR = "fr",
	DE = "de",
	PT = "pt",
}

export enum LeaguePrivacy {
	PUBLIC = "public",
	PRIVATE = "private",
}

export enum LeagueType {
	REGULAR = "regular",
	OVERALL = "overall",
}

export enum LeagueStatus {
	COMPLETE = "complete",
	PLAYING = "playing",
	SCHEDULED = "scheduled",
}
export enum PredictionType {
	LIGHT = "light",
	HEAVY = "heavy",
}
export enum ConferenceType {
	NFC = "nfc",
	AFC = "afc",
}

export enum HPGameTabs {
	Schedule = "schedule",
	Standings = "standings",
}

export enum SidebarNavItemType {
	Link = "link",
	ExternalLink = "external-link",
	Button = "button",
}

export enum GameSteps {
	NFC_WEST = "NCW",
	NFC_SOUTH = "NCS",
	NFC_NORTH = "NCN",
	NFC_EAST = "NCE",
	NFC_SEEDING = "NC_Seeding",
	NFC_WILD_CARD = "NC_Wild_Card",
	AFC_WEST = "ACW",
	AFC_SOUTH = "ACS",
	AFC_NORTH = "ACN",
	AFC_EAST = "ACE",
	AFC_SEEDING = "AC_Seeding",
	AFC_WILD_CARD = "AC_Wild_Card",
}

export enum SyndicatesType {
	US = "us",
	AU = "au",
	FR = "fr",
	DE = "de",
	CA = "ca",
	BR = "br",
	UK = "uk",
}

export enum IncreaseTarget {
	Wins,
	Losses,
}

export enum SortedType {
	WinnerStandings,
	RestStandings,
}
